import { select, getHeight, getTopOffset } from 'helpers/dom'
import './reviews-rating.css'

const selectors = {
  HEADER_SELECTOR: '.header-sticky',
  REVIEWS_FORM_SELECTOR: '.reviews-form',
  REVIEWS_RATING_CONTENT_SELECTOR: '.ruk-rating-snippet-count',
  YOTPO_WIDGET_SELECTOR: 'product-reviews',
  REVIEW_RATINGS_SELECTOR: 'reviews-rating .yotpo-widget-instance',
  REVIEW_PHOTOS_SELECTOR: '[data-review-photos]',
  YOTPO_MEDIA_FILTER_SELECTOR: '.yotpo-media-select',
  YOTPO_MOBILE_FILTER_SELECTOR: '.yotpo-mobile-filters-btn',
  YOTPO_FILTER_SELECTOR: '.yotpo-mobile-filters-popup-overlay-container',
  YOTPO_CLOSE_FILTER_SELECTOR: '.yotpo-mobile-filters-results-btn',
  YOTPO_STAR_RATING_SELECTOR: '.yotpo-reviews-star-ratings-widget'
}

class ReviewsRating extends HTMLElement {
  constructor() {
    super()
    this.yotpoWidgetLoaded = false
    this.intersectionObserver = null
    this.init()
  }

  init() {
    const reviewPhotosEl = this.querySelector(selectors.REVIEW_PHOTOS_SELECTOR)
    if (reviewPhotosEl) {
      reviewPhotosEl.addEventListener('click', (e) => {
        e.stopPropagation()
        this.scrollToYotpoWidget()
        this.handleMobileAndMediaFilters()
      })
    }

    const ratingsSelector = this.querySelector(selectors.REVIEW_RATINGS_SELECTOR)
    if (ratingsSelector) {
      ratingsSelector.addEventListener('click', (e) => {
        e.stopPropagation()
        this.scrollToYotpoWidget()
        this.toggleYotpoMediaFilter()
      })
    }

    setTimeout(() => {
      const starRatingEl = this.querySelector(selectors.YOTPO_STAR_RATING_SELECTOR)
      if (starRatingEl) {
        reviewPhotosEl.classList.remove('hidden')
      }
    }, 3000)
  }

  scrollToYotpoWidget() {
    const yotpoWidget = select(selectors.YOTPO_WIDGET_SELECTOR)

    if (yotpoWidget) {
      const headerEl = select(selectors.HEADER_SELECTOR)
      const headerStickyHeight = window.innerWidth < 768 ? 56 : 64
      const offset = getTopOffset(yotpoWidget) - getHeight(headerEl) - headerStickyHeight

      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      })
    }
  }

  handleMobileAndMediaFilters() {
    const mobileFilterElements = document.querySelectorAll(selectors.YOTPO_MOBILE_FILTER_SELECTOR)
    if (mobileFilterElements.length > 0) {
      mobileFilterElements.forEach(mobileFilterEl => {
        if (mobileFilterEl.offsetParent !== null) {
          mobileFilterEl.click()
        }
      })

      setTimeout(() => {
        const filterElement = document.querySelector(selectors.YOTPO_FILTER_SELECTOR)
        if (filterElement) {
          filterElement.style.opacity = '0'
        }
        this.clickYotpoMediaFilter()
      }, 500)
    } else {
      this.clickYotpoMediaFilter()
    }
  }

  clickYotpoMediaFilter() {
    const mediaFilterElements = document.querySelectorAll(selectors.YOTPO_MEDIA_FILTER_SELECTOR)
    mediaFilterElements.forEach(mediaFilterEl => {
      const isAlreadyPressed = mediaFilterEl.getAttribute('aria-pressed') === 'true'
      if (!isAlreadyPressed) {
        mediaFilterEl.click()

        setTimeout(() => {
          this.clickYotpoCloseFilter()
        }, 1000)
      }
    })
  }

  clickYotpoCloseFilter() {
    const closeFilterElements = document.querySelector(selectors.YOTPO_CLOSE_FILTER_SELECTOR)
    const filterElement = document.querySelector(selectors.YOTPO_FILTER_SELECTOR)

    if (closeFilterElements) {
      closeFilterElements.click()
    }

    if (filterElement) {
      filterElement.style.opacity = '1'
    }
  }

  toggleYotpoMediaFilter() {
    const mediaFilterElements = document.querySelectorAll(selectors.YOTPO_MEDIA_FILTER_SELECTOR)
    mediaFilterElements.forEach(mediaFilterEl => {
      const isCurrentlyPressed = mediaFilterEl.getAttribute('aria-pressed') === 'true'

      if (isCurrentlyPressed) {
        mediaFilterEl.click()
      }
    })
  }

  disconnectedCallback() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect()
    }
  }
}

if (!customElements.get('reviews-rating')) {
  customElements.define('reviews-rating', ReviewsRating)
}
